const version = "2.7.8";

export { version };
//# sourceMappingURL=version.mjs.map
